// extracted by mini-css-extract-plugin
var _1 = "YEZuG";
export { _1 as "buttons" }
